var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useSelector } from "react-redux";
import moment from "moment";
import React from "react";
import { ESubProductIds } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
import { addCommasWithoutEffectingDecimals } from "@domains/utils/numberMethods";
import { EBuySellFlag } from "@domains/features/Markets/OTC/entities/CashFlow";
var formatDate = function (date) {
    return date ? moment(String(date)).format("DD MMM YY") : "-";
};
var safeValue = function (val) {
    return val !== undefined && val !== null ? String(val) : "-";
};
var formatCurrency = function (value) {
    return addCommasWithoutEffectingDecimals(Number(value).toFixed(2)) || "-";
};
var getDetailItem = function (label, value, valueClassName, icon, formatAsCommaNumber) {
    var _a;
    if (valueClassName === void 0) { valueClassName = "Roboto_13_400"; }
    if (formatAsCommaNumber === void 0) { formatAsCommaNumber = false; }
    return ({
        label: label,
        value: formatAsCommaNumber
            ? (_a = addCommasWithoutEffectingDecimals(Number(value))) !== null && _a !== void 0 ? _a : "-"
            : safeValue(value),
        valueClassName: valueClassName,
        icon: icon,
    });
};
export var useProductDetails = function (subCategoryId) {
    var _a = useSelector(function (state) { return state.markets.Otc.productBouquetReducer; }), productDetails = _a.productDetails, watchListRequestPayload = _a.watchListRequestPayload;
    var data = productDetails === null || productDetails === void 0 ? void 0 : productDetails.data;
    var commonDateFields = [
        {
            label: "Issue Date",
            value: formatDate(data === null || data === void 0 ? void 0 : data.issuance_date),
            valueClassName: "Roboto_13_400",
        },
        {
            label: "Maturity Date (Remaining Period)",
            value: "".concat(formatDate(data === null || data === void 0 ? void 0 : data.maturity_date), " (").concat(safeValue(data === null || data === void 0 ? void 0 : data.remain_period), ")"),
            valueClassName: "Roboto_13_400",
        },
    ];
    switch (subCategoryId) {
        case ESubProductIds.Bonds:
            return __spreadArray([
                getDetailItem("Available Qty", (watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.buysellflg) === EBuySellFlag.BUY
                    ? data === null || data === void 0 ? void 0 : data.virtual_buy_qty
                    : data === null || data === void 0 ? void 0 : data.avl_qty, "Roboto_13_400", React.createElement(React.Fragment, null), true),
                getDetailItem("Price Range (₹)", (watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.buysellflg) === EBuySellFlag.BUY
                    ? data === null || data === void 0 ? void 0 : data.price_range_buy
                    : data === null || data === void 0 ? void 0 : data.price_range),
                getDetailItem("Coupon (%)", data === null || data === void 0 ? void 0 : data.coupon_rate),
                getDetailItem("Payout Freq.", data === null || data === void 0 ? void 0 : data.interest_frequency, "DMSans_13_400")
            ], __read(commonDateFields), false);
        case ESubProductIds.NCD:
            return [
                getDetailItem("Face Value (₹)", data === null || data === void 0 ? void 0 : data.face_value, "Roboto_13_400", React.createElement(React.Fragment, null), true),
                getDetailItem("Coupon (%)", data === null || data === void 0 ? void 0 : data.coupon_rate),
                // getDetailItem("Est. Yield (%)", ""),
                getDetailItem("Tenure", data === null || data === void 0 ? void 0 : data.tenure, "DMSans_13_400"),
                getDetailItem("Maturity Value", "\u20B9".concat(formatCurrency(data === null || data === void 0 ? void 0 : data.maturity_value)), "Roboto_13_400"),
            ];
        case ESubProductIds.UnlistedShares:
            return [
                getDetailItem("Face Value (₹)", data === null || data === void 0 ? void 0 : data.face_value, "Roboto_13_400", React.createElement(React.Fragment, null), true),
                getDetailItem("Depository", data === null || data === void 0 ? void 0 : data.depository_type_name, "DMSans_13_400"),
                getDetailItem("Price Validity", formatDate(data === null || data === void 0 ? void 0 : data.price_valid_till)),
                getDetailItem("Risk category", data === null || data === void 0 ? void 0 : data.risk_name, "DMSans_13_400"),
                getDetailItem("Entity", data === null || data === void 0 ? void 0 : data.entity_name, "DMSans_13_400"),
                getDetailItem("Lot Size", data === null || data === void 0 ? void 0 : data.minimum_units, "Roboto_13_400"),
            ];
        case ESubProductIds.StructuredProducts:
            return __spreadArray([
                getDetailItem("Price Range (₹)", (watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.buysellflg) === EBuySellFlag.BUY
                    ? data === null || data === void 0 ? void 0 : data.price_range_buy
                    : data === null || data === void 0 ? void 0 : data.price_range),
                getDetailItem("Tenure", data === null || data === void 0 ? void 0 : data.tenure)
            ], __read(commonDateFields), false);
        default:
            return [];
    }
};
